const state = {
    list: [],
    overriders: {
        pop: {},
    },
};

const getters = {
    list(state) {
        return state.list;
    },
};

const actions = {
};

const mutations = {
    push(state, sideblock) {
        let itemToAdd = sideblock;
        if (typeof sideblock === 'string') {
            itemToAdd = {
                name: sideblock,
                props: {},
            };
        }
        if (!itemToAdd.props) {
            itemToAdd.props = {};
        }
        state.list = state.list.concat([ itemToAdd ]);
    },
    pop(state) {
        const length = state.list.length;
        const overriddenPop = state.overriders.pop[state.list[length - 1].name];
        if (overriddenPop) {
            overriddenPop();
            return;
        }
        const onClose = state.list[length - 1].props.onClose;
        if (onClose !== undefined) {
            onClose();
        }
        state.list = state.list.slice(0, length - 1);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
